import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// MUI Imports
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CancelPresentationOutlinedIcon from '@mui/icons-material/CancelPresentationOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InventoryIcon from '@mui/icons-material/Inventory';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Avatar from "@mui/material/Avatar";
import MuiTooltip from '@mui/material/Tooltip';

// Component imports
import ToolTip from "../Components/Interactive/ToolTip";

// Static Asset Imports
import scLogoBig from "../Assets/img/scLogo.png";
import scLogoSmall from "../Assets/img/sc-logo-small.png";

// Redux Imports
import { logout } from "../Redux/Actions/userActions";

const navLinks = [
  {
    Title: "Home",
    Icon: <HomeIcon fontSize="medium" />,
    LinkTo: "/Home",
    PathName: "home",
  },
  {
    Title: "Search Orders",
    Icon: <SearchIcon fontSize="medium" />,
    LinkTo: "/Search",
    PathName: "search",
  },
  {
    Title: "Opt Out",
    Icon: <CancelPresentationOutlinedIcon fontSize="medium" />,
    LinkTo: "/OptOut",
    PathName: "optout",
  },
  {
    Title: "Place Order",
    Icon: <InventoryIcon fontSize="medium" />,
    LinkTo: "/Order",
    PathName: "order",
  },
  {
    Title: "Latest Leads",
    Icon: <PeopleOutlineIcon fontSize="medium" />,
    LinkTo: "/Leads",
    PathName: "leads",
  },
  {
    Title: "Create Influencer",
    Icon: <PhoneIphoneIcon fontSize="medium" />,
    LinkTo: "/Influencer",
    PathName: "influencer",
  },
  {
    Title: "Self Opt Out",
    Icon: <VisibilityOffIcon fontSize="medium" />,
    LinkTo: "/SelfOptOut",
    PathName: "selfoptout",
  }
];
const SlidingMenuBar = ({ isOpen, setIsOpen, toggledMenu, setToggledMenu }) => {
  const [location, setLocation] = useState("");
  const [isProd, setIsProd] = useState(localStorage.getItem("NODE_ENV" || "development") === "production");
  const userAuth = useSelector((state) => state.auth);
  const isAdmin = userAuth?.userInfo?.userData?.role === "Administrator";
  const isAdminOrSuperUser = userAuth?.userInfo?.userData?.role === "Administrator" || userAuth?.userInfo?.userData?.role === "Super User" || userAuth?.userInfo?.userData?.role === "Supervisor";
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const loc = window.location.href;
    if(loc.includes('https://crm.scalablecommerce.com')) setIsProd(true);
    return navigate((loc) =>{
      setLocation(loc.pathname.split("/")[1].toLowerCase())
    });
  }, [navigate]);

  return (
    <nav
      className={`menu ${isOpen ? "menu-opened" : "menu-closed"} 
        ${toggledMenu && isOpen === true ? "animatation-open" : null}
        ${toggledMenu && isOpen === false ? "animatation-close" : null}
        `}
    >
      {isOpen ? (
        <img
          src={scLogoBig}
          alt="Scalable Commerce Logo"
          className="scalable-logo big-logo"
          style={{ width: "120px", cursor: "pointer" }}
          onClick={() => navigate.push("/Home")}
          title="Home"
        />
      ) : (
        <img
          src={scLogoSmall}
          alt="Scalable Commerce Logo"
          className="scalable-logo small-logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate.push("/Home")}
          title="Home"
        />
      )}
      {/* Navigation Container */}
      <div className="list-container">
        {navLinks.map(({ Title, Icon, LinkTo, PathName }, i) => {
          // Dont show the place order link if on production
          if(i === 3 && isProd) return null;
          // Dont show the influencer link if user is not an admin or super user
          if(i === 5 && !isAdminOrSuperUser) return null;
          // Dont show the self serve opt out link if user is not an admin
          if(i === 6 && !isAdmin) return null;
          return (
            <MuiTooltip key={Title} title={Title} placement="right">
              <Link to={LinkTo} key={i} className="menu-list-item">
                  <i className="menu-icon">{Icon}</i>
                  {isOpen ? <p className="link_text">{Title}</p> : null}
              </Link>
            </MuiTooltip>
          )
        })}
      </div>
      <ToolTip placement="right" titleHeading="Press / to toggle open the sidebar">
        <KeyboardArrowRightIcon
          onClick={() => {
            setIsOpen(!isOpen);
            setToggledMenu(true);
          }}
          className={`toggle-sidebar-menu-icon ${
            isOpen
              ? "toggle-sidebar-menu-icon-opened"
              : "toggle-sidebar-menu-icon-closed"
          }`}
        />
      </ToolTip>

      <div className="logout-container">
        {isOpen ? (
          <>
            <Avatar
              className="user-animation"
              alt="user image"
              src={userAuth?.userInfo?.userData?.imageUrl}
              style={{ borderRadius: "50%", height: "1.4rem", width: "1.4rem" }}
            />
            <p style={{ paddingLeft: "5px" }} className="user-animation">
              {userAuth?.userInfo?.userData?.displayName}
            </p>
            <p className="admin user-animation">
              Role: { userAuth?.userInfo?.userData?.role }
            </p>
          </>
        ) : null}
        <MuiTooltip title="Logout" placement="right">
          <ExitToAppIcon
            style={{ margin: "0 auto" }}
            fontSize="small"
            className="logout-btn"
            onClick={() => dispatch(logout(navigate))}
          />
        </MuiTooltip>
      </div>
    </nav>
  );
};

export default SlidingMenuBar;
